import { IPageHeader } from '../../interfaces/pageHeader.interface';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import Debug from 'debug';
import { AumBreadcrumbComponentItem } from '../breadcrumb/breadcrumb';
import { ActionHeaderService, AumGlobalAction, IAumGlobalActionEvent } from './actionHeader.service';

const debug = Debug('aumico:aumico-lib-core-fe:AumActionHeader');
@Component({
    selector: 'aum-action-header',
    styleUrls: ['./action-header.scss'],
    templateUrl: './action-header.html',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'aum-action-header',
    },
})
export class AumActionHeader {
    @Input()
    public hasBreadscrumb: boolean = false;
    @Input()
    public breadcrumbItems?: AumBreadcrumbComponentItem[] = [];

    @Input()
    public hasBackButton: boolean = false;

    @Input()
    public backButtonRoute?: string;

    @Input()
    public pageHeader: IPageHeader = {
        isLocalizedKey: true,
        value: 'aumico_reports_default_page_header',
    };

    @Input()
    public searchText: string = undefined;

    @Input()
    public filterText: string = undefined;

    @Input()
    public actionText: string = undefined;

    @Input()
    public hasBackForth: boolean = false;

    searchFormControl = new UntypedFormControl({ value: '', disabled: false }, []);

    constructor(private actionHeaderService: ActionHeaderService) {}

    onFilter() {
        const event: IAumGlobalActionEvent = {
            action: AumGlobalAction.FILTER,
            value: true,
        };
        this.actionHeaderService.onAction(event);
    }

    onSearch(searchEvent) {
        debug(searchEvent);
        const event: IAumGlobalActionEvent = {
            action: AumGlobalAction.SEARCH,
            value: this.searchFormControl.value,
        };
        this.actionHeaderService.onAction(event);
    }

    onNew() {
        const event: IAumGlobalActionEvent = {
            action: AumGlobalAction.NEW,
            // TODO: the value can define what happens when clicked
            value: true,
        };
        this.actionHeaderService.onAction(event);
    }

    onUndo() {
        const event: IAumGlobalActionEvent = {
            action: AumGlobalAction.UNDO,
            value: true,
        };
        this.actionHeaderService.onAction(event);
    }

    onRedo() {
        const event: IAumGlobalActionEvent = {
            action: AumGlobalAction.REDO,
            value: true,
        };
        this.actionHeaderService.onAction(event);
    }

    onBack() {
        if (this.backButtonRoute === undefined) {
            const event: IAumGlobalActionEvent = {
                action: AumGlobalAction.GOBACK,
                // TODO: the value can define where to navigate back
                value: true,
            };
            this.actionHeaderService.onAction(event);
        }
    }
}
